import React from 'react';
import ReorderRuleScreen from './ReorderRuleScreen';

export default function CreateReorderRuleScreen() {
  return <ReorderRuleScreen />;
}
